// extracted by mini-css-extract-plugin
module.exports = {"badge":"Cards_badge__393U-","cards":"Cards_cards__3lktC","img":"Cards_img__1TFDR"};